export const SHOPPING_CART_PRODUCT_REMOVE = 'SHOPPING_CART_PRODUCT_REMOVE';
